import React from 'react';

const ErrorDisplay = ({ error = [], onDismiss }) => {
  if (!error || error.length === 0) return null;

  return (
    <div className="container mt-2">
      <div className="bg-red-50 border-l-4 border-red-400 p-4 relative card">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <ul className="list-disc pl-5 space-y-1">
              {Array.isArray(error) ? (
                error.map((err, index) => (
                  <li key={index} className="text-sm text-red-700">
                    {err || 'An error occurred'}
                  </li>
                ))
              ) : (
                <li className="text-sm text-red-700">
                  {error || 'An error occurred'}
                </li>
              )}
            </ul>
          </div>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="absolute top-4 right-4 text-red-400 hover:text-red-500"
            >
              <span className="sr-only">Dismiss</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay; 